<template>
  <div class="page activity-detail">
    <activity-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></activity-detail-skeleton>

    <div v-else>
      <div class="activity-detail-box">
        <h3 class="activity-detail-title">{{ detail.title }}</h3>
        <div style="padding: 0 15px 15px">
          <div class="activity-detail-time">{{ detail.created_at }} 阅读 {{ detail.view_count }}</div>
        </div>
        <div class="clear" style="margin-top: 15px"></div>

        <div>
          <div class="activity-detail-content">
            <div class="rich_media_inner" v-html="detail.article.content"></div>
          </div>
        </div>
      </div>

      <div class="activity-detail-footer">
        <div class="activity-detail-footer-box">
          <div class="activity-detail-footer-right" style="width: 100%">
            <van-grid direction="horizontal" :column-num="3" :border="false">
              <van-grid-item
                @click="favorite()"
                v-if="detail.isFavorite"
                icon="/static/img/course/icon_course_favorite_on_20.svg"
                text="已收藏"
              />
              <van-grid-item
                @click="favorite()"
                v-else
                icon="/static/img/course/icon_course_favorite_off_20.svg"
                text="收藏"
              />
              <van-grid-item
                @click="pointLike()"
                v-if="detail.isLike"
                icon="/static/img/course/icon_course_like_on.svg"
                text="有帮助"
                :badge="detail.like_count"
              />
              <van-grid-item
                @click="pointLike()"
                v-else
                icon="/static/img/course/icon_course_like_off.svg"
                text="有帮助"
                :badge="detail.like_count"
              />
              <van-grid-item
                @click="openShareData"
                icon="/static/img/course/icon_course_share_20.svg"
                text="转发"
              />
            </van-grid>
          </div>
        </div>
        <van-number-keyboard safe-area-inset-bottom />
      </div>

      <van-overlay :show="showShareDialog" @click="showShareDialog = false">
        <div class="share-box">
          <div class="block">请点击 “...”，再点击发送给朋友 | <span>知道啦</span></div>
          <div class="share-box-bottom">
            <img src="/static/bytx/detail_forward_2_img.png" alt="" />
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'
import articleDetailSkeleton from '@/skeleton/articleDetailSkeleton'

export default {
  name: 'activity-detail',
  components: {
    'activity-detail-skeleton': articleDetailSkeleton
  },
  data() {
    return {
      id: 0,
      value: '',
      active: '',
      category_id: 0,
      category_child_id: 0,
      banners: [],
      categories: [],
      categories_child: [],
      recommend: [],
      list: [],
      column: [],
      article: {},
      comment: [],
      comment_text: '',
      loading: true,
      share_data: {},
      showShareDialog: false,
      htmlUrl: '',
      isShow: false,
      status: '',
      comment_id: 0,
      to_user_id: 0,
      comment_placeholder: '写评论',
      user_id: 0,
      detail: {}
    }
  },
  methods: {
    fetch(scene) {
      if (scene === 'detail') {
        Interface.getData('get', Interface.activity.detail + this.id).then(res => {
          this.detail = res.data
          setTimeout(() => {
            this.loading = false
          }, 500)
          if (this.detail) {
            Interface.getShareInfo(this, this.detail.title, this.detail.cover_img, '')
          }
        })
      } else if (scene === 'footprint') {
        let params = {
          id: this.id,
          type: 5
        }
        Interface.getData('post', Interface.footprint, params).then(res => {})
      }
    },
    changeCategory() {
      this.fetch('article')
    },
    favorite() {
      Interface.getData('get', Interface.activity.favorite + this.id).then(res => {
        if (res.code == 0) {
          this.detail.isFavorite = !this.detail.isFavorite
        }
      })
    },
    pointLike() {
      Interface.getData('get', Interface.activity.like + this.id).then(res => {
        if (res.code == 0) {
          this.detail.isLike = !this.detail.isLike
          this.detail.like_count = !this.detail.isLike
            ? parseInt(this.detail.like_count) - 1
            : parseInt(this.detail.like_count) + 1
        }
      })
    },
    reComment(item) {
      this.comment_placeholder = '回复' + item.nickname
      this.comment_id = item.id
    },
    reCommentChild(item) {
      this.comment_placeholder = '回复' + item.nickname
      this.comment_id = item.comment_id
      this.to_user_id = item.user_id
    },
    pointLikeComment(item) {
      Interface.getData('get', Interface.pointLikeComment + item.id).then(res => {
        if (res.code == 0) {
          item.isLike = !item.isLike
          if (item.isLike) {
            item.like_count += 1
          } else {
            item.like_count -= 1
          }
        }
      })
    },
    goComment() {
      this.$el.querySelector('.comment').scrollIntoView()
    },
    openShareData() {
      this.showShareDialog = true
    }
  },
  created() {
    this.id = this.$route.params.id
    this.fetch('detail')
    this.fetch('footprint')
    this.fetch('share')
  }
}
</script>

<style lang="scss">
@import './index';
@import '../../../components/comment';
</style>



// WEBPACK FOOTER //
// src/views/activity/detail/index.vue